import styled from 'styled-components'
import { deviceMax } from '../../theme/breakpoints'
import pxToRem from '../../utils/pxToRem'
import CloseButtonSvg from '../../images/icons/close-modal.svg'
import ButtonDownload from '../ButtonDownload/ButtonDownload'

export const StyledModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.opacity.black90};
`

export const StyledMediaViewer = styled.div`
  overflow: hidden;
  position: relative;
  display: flex;
  background-color: transparent;
  width: 100%;
  max-width: ${pxToRem(1116)};
  padding: 20px;
  
  @media ${deviceMax.mobileL} {
    flex-direction: column;
  }
  
`

export const StyledCloseButtonDiv = styled.div`
  position: absolute;
  z-index: 55;
  right: 40px;
  top:0;
  width: 32px;
  height: 32px;
  border-radius: 100px;
  background-color: ${({ theme }) => theme.colors.unique.white};

  @media ${deviceMax.mobileL} {
    right: 0;
  }
`

export const CloseButton = styled(CloseButtonSvg)`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  cursor: pointer;
`

export const StyledCard = styled.div`
  overflow: hidden;
  flex-direction: column;
  display: flex;
  background-color: ${({ theme }) => theme.colors.unique.white};
  width: 100%;
  max-width: ${pxToRem(996)};
  
  @media ${deviceMax.mobileM} {
    flex-direction: column;
    overflow: hidden;
    align-items: center;
  }
`

export const StyledMedia = styled.div`
  height: ${pxToRem(580)};
  width: 100%;
  min-width: ${pxToRem(996)};
  
  img,
  video,
  iframe {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  @media ${deviceMax.tablet} {
    min-width: auto;
  }
  
  @media ${deviceMax.mobileL} {
    height: ${pxToRem(200)};
  }
`

export const StyledBody = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${pxToRem(16)};
  height: ${pxToRem(82)};
  gap: ${pxToRem(24)};

  @media ${deviceMax.tablet} {
    flex-wrap: wrap;
  }

  @media ${deviceMax.mobileL} {
    flex-direction: column;
    overflow: hidden;
    gap: ${pxToRem(12)};
    width: 100%;
    height: 100%;
  }
`

export const StyledSubtitleContainer = styled.div`
  flex-direction: column;
  display: flex;
  font-size: ${({ theme }) => theme.fonts.sizes.button};
  color: ${({ theme }) => theme.colors.opacity.black70};
`

export const StyledTitle = styled.h2`
  max-width: ${pxToRem(756)};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  font-size: ${({ theme }) => theme.fonts.sizes.titleH2};
  line-height: ${({ theme }) => theme.fonts.lineHeight.titleH2};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  
  @media ${deviceMax.tablet} {
    margin-top: initial;
  }
  @media ${deviceMax.mobileL} {
    white-space: normal;
    font-size: ${({ theme }) => theme.fonts.sizes.titleH3};
    line-height: ${({ theme }) => theme.fonts.lineHeight.titleH3};
  }
  
`

export const StyledSubtitle = styled.h3`
  max-width: ${pxToRem(756)};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: ${({ theme }) => theme.fonts.lineHeight.base};
  color: ${({ theme }) => theme.colors.primary.grey};

  @media ${deviceMax.mobileL} {
    white-space: normal;
    font-size: ${({ theme }) => theme.fonts.sizes.md};
    line-height: ${({ theme }) => theme.fonts.lineHeight.md};
  }
  
`

export const StyledButtonDownload = styled(ButtonDownload)`
  flex-grow: unset;
  width: auto;
  
  a {
    max-width: unset;
  }
`

export const StyledActions = styled.div`
  display: flex;
  margin-top: 24px;
  justify-content: center;
  gap: 24px;
`